
const PROD_URL = 'https://d64is2qkxbhv3.cloudfront.net/assets/dist';
const STAGE_URL = 'https://d2v0lj9tfbnmhu.cloudfront.net/assets/dist';

export const isProd = process.env.REACT_APP_ENVIRONMENT === 'production';

export const SVG_HOST_URL = isProd ? PROD_URL : STAGE_URL;
